var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPowerDistributionLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    enableBackground: "new 0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "K7_2_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9,7h5.7c0.2,0,0.4,0.2,0.4,0.4v12.4c0,0.2-0.2,0.4-0.4,0.4H9c-0.2,0-0.4-0.2-0.4-0.4V7.4 C8.6,7.2,8.8,7,9,7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "K7_00000022536195392620655770000018221662600075477637_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M20.4,7h5.7c0.2,0,0.4,0.2,0.4,0.4v12.4c0,0.2-0.2,0.4-0.4,0.4h-5.7c-0.2,0-0.4-0.2-0.4-0.4V7.4 C20,7.2,20.2,7,20.4,7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "K7_00000090275693585528854100000000013156967554954165_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M31.8,7h5.7c0.2,0,0.4,0.2,0.4,0.4v12.4c0,0.2-0.2,0.4-0.4,0.4h-5.7c-0.2,0-0.4-0.2-0.4-0.4V7.4 C31.4,7.2,31.6,7,31.8,7z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "K7_00000137127932543889254740000014059336264247814547_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M43.2,7h5.7c0.2,0,0.4,0.2,0.4,0.4v12.4c0,0.2-0.2,0.4-0.4,0.4h-5.7c-0.2,0-0.4-0.2-0.4-0.4V7.4 C42.8,7.2,43,7,43.2,7z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "K7_00000026881021890659727420000012054278124626910618_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9,23.6h5.7c0.2,0,0.4,0.2,0.4,0.4v12.4c0,0.2-0.2,0.4-0.4,0.4H9c-0.2,0-0.4-0.2-0.4-0.4V24 C8.6,23.8,8.8,23.6,9,23.6z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "K7_00000125591965197247165970000000220911388582584707_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M20.4,23.6h5.7c0.2,0,0.4,0.2,0.4,0.4v12.4c0,0.2-0.2,0.4-0.4,0.4h-5.7c-0.2,0-0.4-0.2-0.4-0.4V24 C20,23.8,20.2,23.6,20.4,23.6z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "K7_00000032630395566749880590000002649324383524716931_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M31.8,23.6h5.7c0.2,0,0.4,0.2,0.4,0.4v12.4c0,0.2-0.2,0.4-0.4,0.4h-5.7c-0.2,0-0.4-0.2-0.4-0.4V24 C31.4,23.8,31.6,23.6,31.8,23.6z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "K7_00000010295582626675425790000000085722468129772941_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M43.2,23.6h5.7c0.2,0,0.4,0.2,0.4,0.4v12.4c0,0.2-0.2,0.4-0.4,0.4h-5.7c-0.2,0-0.4-0.2-0.4-0.4V24 C42.8,23.8,43,23.6,43.2,23.6z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "K7_00000109743125701298772820000009151828736432780162_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M43.2,40.1h5.7c0.2,0,0.4,0.2,0.4,0.4v11.4c0,0.2-0.2,0.4-0.4,0.4h-5.7c-0.2,0-0.4-0.2-0.4-0.4V40.5 C42.8,40.3,43,40.1,43.2,40.1z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "K6_00000101102203572670007960000015901545027891983764_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M25.5,46.1h9.2c0.2,0,0.4,0.2,0.4,0.4v5.7c0,0.2-0.2,0.4-0.4,0.4h-9.2c-0.2,0-0.4-0.2-0.4-0.4v-5.7 C25.1,46.3,25.2,46.1,25.5,46.1z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "K5_00000146463249044103923750000002102618160930164661_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M20.7,52.5h-9.4c-0.2,0-0.4-0.2-0.4-0.4v-5.6c0-0.2,0.2-0.4,0.4-0.4h9.3c0.2,0,0.4,0.2,0.4,0.4v5.6 C21,52.3,20.9,52.5,20.7,52.5z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "BOX"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M57.4,59.7H2.2c-1,0-1.9-0.9-1.9-1.9V2.3c0-1,0.9-1.9,1.9-1.9h55.1c1,0,1.9,0.9,1.9,1.9v55.4 C59.2,58.8,58.4,59.7,57.4,59.7z M3.3,56.7h52.9V3.4H3.3V56.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPowerDistributionLight);
export default __webpack_public_path__ + "static/media/ic-power-distribution-light.fcb908fcdde5f8d7837ec6a7252c4a94.svg";
export { ForwardRef as ReactComponent };